import React from 'react';
import { IBuyboxViewPropsExtended } from '../types';
import { SleepExpertSummaryComponent } from '../../../themes/mattressfirm/custom-components/sleep-expert-summary-component';


export const BuyboxSleepExpertSummary = (props:{buyboxProps: IBuyboxViewPropsExtended, sleepExpertSummaryText: string | undefined}): JSX.Element => {
    const {buyboxProps, sleepExpertSummaryText} = props;
    const sleepExpertOpinionHeadingText = buyboxProps.config.sleepExpertOpinionHeadingText ?? '';
    return sleepExpertSummaryText ? (
        <SleepExpertSummaryComponent
            sleepExpertOpinionHeadingText={sleepExpertOpinionHeadingText}
            sleepExpertSummaryText={sleepExpertSummaryText}
        />
    ) : (
        <></>
    );
};